import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BilibiliFilledSvg from "@ant-design/icons-svg/es/asn/BilibiliFilled";
import AntdIcon from "../components/AntdIcon";
var BilibiliFilled = function BilibiliFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BilibiliFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BilibiliFilled.displayName = 'BilibiliFilled';
}
export default /*#__PURE__*/React.forwardRef(BilibiliFilled);